import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';

const getPatientFullPhone = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const phone1 = getPatientPhone1(otherProps);
  const phone2 = getPatientPhone2(otherProps);
  const phone3 = getPatientPhone3(otherProps);
  if (phone1 && phone2 && phone3) {
    return `(${phone1}) ${phone2}-${phone3}`;
  }

  return null;
};

export default getPatientFullPhone;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientFullPhone.js